import { toast } from "sonner";

/**
 * Bloque de diagnóstico OAuth — siempre visible para detectar `invalid_grant`
 * y verificar que la Redirect URI registrada en Google Cloud coincide.
 */
export default function GoogleDebugPanel({ debug }) {
  if (!debug) return null;

  const copyRedirect = async () => {
    try {
      await navigator.clipboard.writeText(debug.redirect_uri || "");
      toast.success("Redirect URI copiada");
    } catch (err) {
      console.warn("[GoogleDebugPanel] copyRedirect failed:", err);
    }
  };

  return (
    <div className="bg-[#FAFAF8] border border-[#E5E5E0] p-4 text-xs">
      <div className="font-mono text-[10px] uppercase tracking-widest text-[#525252] mb-2">
        // Diagnóstico OAuth
      </div>
      <div className="space-y-1.5 font-mono">
        <Row label="Client ID" value={`${debug.client_id_prefix}…${debug.client_id_suffix}`} />
        <Row
          label="Client secret"
          value={debug.client_secret_set ? `${debug.client_secret_prefix}… (configurado)` : "✗ FALTA"}
          warn={!debug.client_secret_set}
        />
        <div className="flex items-center gap-2 flex-wrap">
          <span className="w-32 shrink-0 text-[#525252]">Redirect URI:</span>
          <code className="ds-card px-2 py-0.5 text-[11px] break-all">
            {debug.redirect_uri || "(vacío)"}
          </code>
          <button
            onClick={copyRedirect}
            className="text-[10px] uppercase tracking-wider border border-[#E5E5E0] px-2 py-0.5 hover:bg-white"
            data-testid="google-copy-redirect"
          >
            Copiar
          </button>
        </div>
        <Row label="Scopes" value={(debug.scopes || []).join(", ")} />
        {debug.connected && (
          <>
            <Row
              label="Refresh token"
              value={debug.has_refresh_token ? "✓ guardado" : "✗ NO presente"}
              warn={!debug.has_refresh_token}
            />
            <Row
              label="Access token"
              value={
                debug.has_access_token
                  ? `✓ válido hasta ${debug.expiry_date ? new Date(debug.expiry_date).toLocaleString("es-ES") : "—"}`
                  : "✗ NO presente"
              }
            />
            <Row label="Cuenta" value={debug.email} />
          </>
        )}
      </div>
      <div className="mt-3 text-[11px] text-[#525252] leading-relaxed border-t border-[#E5E5E0] pt-2">
        <strong>
          Si ves <code className="bg-white px-1">invalid_grant</code>
        </strong>
        : la URI de arriba debe coincidir EXACTAMENTE con la que registraste en Google Cloud
        Console → <em>APIs &amp; Services → Credentials → tu OAuth Client → Authorized redirect URIs</em>.
        Cualquier diferencia (mayúsculas, http/https, slash final, www) causa el error. Pulsa
        &quot;Copiar&quot; y pégala literal en Google Cloud.
      </div>
    </div>
  );
}

function Row({ label, value, warn }) {
  return (
    <div className="flex items-start gap-2 flex-wrap">
      <span className="w-32 shrink-0 text-[#525252]">{label}:</span>
      <code className={`break-all text-[11px] ${warn ? "text-red-700 font-bold" : "text-[#111110]"}`}>
        {value || "—"}
      </code>
    </div>
  );
}
